import { VertSpacerLg } from '@apps-common/components/layout'

export const OrderUnitCardSkeleton: React.FC = () => (
  <div className='relative bg-skeleton border border-skeleton-border rounded-3xl p-[20px] animate-pulse'>
    <div className='flex items-center justify-between gap-[20px]'>
      <div className='flex flex-col gap-[10px]'>
        <div className='flex items-center justify-start gap-[5px]'>
          <div className='absolute top-[12px] rounded-full bg-skeleton-hi w-[60px] min-h-[14px]' />
        </div>
        <div className='flex items-center justify-start gap-[5px]'>
          <div className='h-[20px] w-[100px] rounded-[15px] flex items-center justify-start gap-[10px] bg-skeleton-hi' />
        </div>
      </div>
      <div className='w-[45px] h-[45px] rounded-full flex items-center justify-center overflow-hidden bg-skeleton-hi' />
    </div>
    <VertSpacerLg />
    <div className='flex items-end justify-between gap-[5px]'>
      <div className='grow flex flex-col gap-[10px]'>
        <div className='bg-skeleton-hi rounded-lg w-[60%] h-[16px]' />
        <div className='bg-skeleton-hi rounded-lg w-[60%] h-[16px]' />
      </div>
      <div className='w-[40px] h-[40px] rounded-full flex items-center justify-center overflow-hidden bg-skeleton-hi' />
    </div>
  </div>
)
